import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';

import { Paragraph } from 'components/core/Typography';
import { StarRating } from 'components/review/StarRating';
import RatingBar from './RatingBar';

import './Review.scss';

const DisplayDateFormat = 'MMM. D, YYYY';
const DateTimeFormat = 'YYYY-MM-DDTHH:mm:ssZ';

function Review({ review, facilityName, dateTimeFormat }) {
	return (
		<div
			className="review"
			itemScope
			itemType="http://schema.org/Review"
			itemProp="review"
		>
			{(review.title || review.message) && (
				<div className="review-header">
					{review.title && (
						<div className="review-title">{review.title}</div>
					)}
					{review.message && (
						<div
							className="review-message"
							itemProp="description"
						>
							{review.message}
						</div>
					)}
				</div>
			)}
			<div className="review-details">
				<div className="review-meta">
					<Paragraph
						className="facility-name"
						itemScope
						itemType="http://schema.org/LocalBusiness"
						itemProp="itemReviewed"
					>
						<span itemProp="name">{facilityName}</span>
					</Paragraph>
					<Paragraph
						size="small"
						className="author"
						itemProp="author"
					>
						<span itemProp="name">{review.nickname}</span>
					</Paragraph>
					<Paragraph className="review-date">
						<time
							itemProp="datePublished"
							dateTime={format(review.timestamp, dateTimeFormat)}
						>
							{format(review.timestamp, DisplayDateFormat)}
						</time>
					</Paragraph>
					<StarRating rating={parseFloat(review.rating)} />
				</div>
				<div className="review-metrics">
					<RatingBar
						name="Price"
						rating={review.ratingPrice}
						outOf={5}
					/>
					<RatingBar
						name="Paperwork"
						rating={review.ratingPaperwork}
						outOf={5}
					/>
					<RatingBar
						name="Service"
						rating={review.ratingService}
						outOf={5}
					/>
					<RatingBar
						name="Cleanliness"
						rating={review.ratingCleanliness}
						outOf={5}
					/>
				</div>
			</div>
			{review.managerResponse && (
				<div className="manager-response">
					<div className="manager-response-header">
						<Paragraph size="small">Manager's Response</Paragraph>
						<Paragraph>
							<time
								itemProp="datePublished"
								dateTime={format(
									review.managerResponse.timestamp,
									dateTimeFormat,
								)}
							>
								{format(
									review.managerResponse.timestamp,
									DisplayDateFormat,
								)}
							</time>
						</Paragraph>
					</div>
					<div className="manager-message">
						{review.managerResponse.message}
					</div>
				</div>
			)}
		</div>
	);
}

Review.propTypes = {
	review: PropTypes.object,
	facilityName: PropTypes.string,
	dateTimeFormat: PropTypes.string,
};

Review.defaultProps = {
	// Gitlab runner has different time zone so jest snapshots fail
	// Making it an optional prop allows tests to not include timesone
	dateTimeFormat: DateTimeFormat,
};

export default Review;
